import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { HELP_NAV, TRUST_NAV } from "../lib/publicDocs";

const subNavClass = ({ isActive }: { isActive: boolean }) =>
	[
		"inline-flex min-h-9 items-center rounded-lg px-3 py-1.5 text-sm font-medium transition-colors",
		isActive ? "bg-wi-text/[0.09] text-wi-text" : "text-wi-text/65 hover:bg-wi-text/[0.05] hover:text-wi-text",
	].join(" ");

export function PublicDocLayout({ variant }: { variant: "help" | "trust" }) {
	const location = useLocation();
	const nav = variant === "help" ? HELP_NAV : TRUST_NAV;
	const hub = variant === "help" ? "/help" : "/trust";

	return (
		<div className="space-y-lg">
			<div className="flex flex-wrap items-end justify-between gap-md border-wi-text/10 border-b pb-md">
				<div>
					<p className="font-medium text-wi-gold text-caption uppercase tracking-[0.18em]">
						{variant === "help" ? "Help" : "Trust Center"}
					</p>
					<h1 className="wi-type-h1 text-wi-text">
						{variant === "help" ? "Team guides" : "Security & compliance"}
					</h1>
				</div>
				<Link to={hub} className="text-body-sm text-wi-gold underline-offset-2 hover:underline">
					{variant === "help" ? "Help home" : "Trust overview"}
				</Link>
			</div>
			<nav className="flex flex-wrap gap-1" aria-label={variant === "help" ? "Help topics" : "Trust topics"}>
				{nav.map((item) => (
					<NavLink key={item.to} to={item.to} className={subNavClass}>
						{item.label}
					</NavLink>
				))}
			</nav>
			<Outlet key={location.pathname} />
		</div>
	);
}
